/* eslint-disable */
import 'isomorphic-fetch'

import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import vuetify from '@/plugins/vuetify'
import '@/registerServiceWorker'
import i18n from '@/core/lang'
import * as Security from '@/core/security'

router.beforeEach((to, from, next) => {
  // Support direct path change, when user is logged in
  if (from.path === '/' && to.path !== '/') { 
    if  (process.env.NODE_ENV === 'development') console.log('route: Save direct path: ', from.path, to.path)
    Security.saveDirectPath(to.path)
  } 

  // If route needs login status
  if (to.matched.some(route => route.meta.auth)) {
    // Check if user is logged in
    if (Security.user.loggedIn) {
      // And if route needs specific claim, check if user has required claim
      if (Security.hasAccess(to.meta.claims)) {
        // If this route has one or more module claims, then save path to db, to remember users last used module
        if  (process.env.NODE_ENV === 'development') console.log('--> Routing from -> to: ',from.path, to.path)

        if (from.path !== to.path) {
          Security.saveLastPath(to.path)
          next()
        }
      }
      else {
        // Go to home on no access
        if (app != null) app.$root.$message.showError('No access ('+to.meta.claims+')')
          next(from)
      }
    } 
    else {
      // Save the from route url to redirect after login
      // todo: consider if we need this
      // Security.setRedirectTo(to.path)
      next('/')
    }
  } 
  else {
    next()
  }

  // REMOVED
  //}
})

// todo: should we use these for something?
router.onError(() => {
  // console.log("--> router.onError") 
})
router.onReady(
  () => {
    // console.log("--> router.onReady")
  },
  () => {
    // console.log("--> router.onReady ERR")
  }
)
window.onerror = function(message, source, lineno, colno, error) {
  console.log('Exception: ', error, message)
}


export const app = new Vue({
  vuetify,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
